import React, { useContext } from 'react';
import { Modal } from 'antd';
import ModalContent from '../../../../atoms/ModalContent';
import PromotionsContext from '../../../../../context/programaRecompensa/Promociones/PromotionsContext';
import useListPromsBanners from '../../../../hooks/useListPromsBanners';

const ActivatePromotionModal = () => {
    const {
        activatePromotion,
        enable,
        id,
        setShowActivatePromotionModal,
        showActivatePromotionModal,
    } = useContext(PromotionsContext);
    const { handleFinish } = useListPromsBanners();

    const handleOk = () => {
        activatePromotion(enable, id);
        handleCancel();
        handleFinish(undefined, true);
    };

    const handleCancel = () => {
        setShowActivatePromotionModal(false);
    };

    return (
        <Modal
            centered
            open={showActivatePromotionModal}
            footer={null}
            closable={false}>
            <ModalContent
                isLoading={false}
                showWarnIcon={true}
                title="¿Estás seguro de activar esta promoción?"
                okText="Activar"
                cancelText="Cancelar"
                onOk={handleOk}
                onCancel={handleCancel}
            />
        </Modal>
    );
};

export default ActivatePromotionModal;
